<template>
  <v-dialog
    v-model="showSetting"
    max-width="450px"
    persistent
  >
    <v-card>
      <v-card-title>
        Settings
        <v-spacer />
        <v-btn
          icon
          @click="close()"
        >
          <v-icon color="error">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container class="px-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.taxSummary"
                inset
                label="Show Tax Summary"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.separateTax"
                inset
                label="Separate Tax"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.groupTaxClassification"
                inset
                label="Group Tax Classification"
                hide-details
              />
            </v-col>
            <!-- <v-col cols="12">
              <v-switch
                v-model="settingInfo.includeModifiers"
                inset
                label="Include Modifiers"
                hide-details
              />
            </v-col> -->
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.excludeZeroPriceModifiers"
                inset
                label="Exclude Zero Price Modifiers"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.separateDiscount"
                inset
                label="Separate Discount"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.taxIdInfo"
                inset
                label="Tax Id Info"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.allInclusive"
                inset
                label="All Inclusive price"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.unitPrice"
                inset
                label="Add unit price"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.showChargePercentage"
                inset
                label="Show Charges Percentage"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.groupSc"
                inset
                label="Group Service charge"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.splitByDepartments"
                inset
                label="Split By Departments"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.netAmount"
                inset
                label="Net Amount"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="settingInfo.discountWithTax"
                inset
                label="Discount With Tax"
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          @click="close()"
        >
          Close
        </v-btn>
        <v-btn
          color="success"
          @click="updateSetting()"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ReceiptSettings",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      settingInfo: {}
    };
  },
  computed: {
    showSetting() {
      return this.show;
    }
  },
  watch: {
    show: {
      handler(v) {
        if (v) {
          this.settingInfo = this.settings;
        }
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },

    updateSetting() {
      this.$emit("update", this.settingInfo);
      this.close();
    }
  }
};
</script>